
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <v-row class="d-flex justify-center mt-3">
                <v-col cols="3">
                    <v-text-field
                    label="Nome da Disciplina"
                    v-model="form.filters.disciplina"
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                <v-autocomplete
                    v-model="form.filters.tipoDisciplina"
                    :items="form.lists.tiposDeDisciplina"
                    label="Tipo de Disciplina"
                    item-text="tipoDisciplina"
                    item-value="id"
                    outlined
                    dense
                ></v-autocomplete>
                </v-col>
                <sigfoco-select-ativo
                    :cols="2"
                    v-model="form.filters.situacao"
                    labelType="Situação"
                ></sigfoco-select-ativo>
              </v-row>
                <v-row class="d-flex justify-center mt-3">
                <sigfoco-date-picker
                :cols="2"
                label="Data Início"
                v-model="form.filters.dataInicio"
                removeIcon
                outlined
                dense
              ></sigfoco-date-picker>
              <sigfoco-date-picker
              :cols="2"
                v-model="form.filters.dataFim"
                label="Data Final"
                removeIcon
                outlined
                dense
              ></sigfoco-date-picker>
            </v-row>
             <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarRelatorios"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5 printable"
          :headers="getFilteredHeader(headersAnalitico)"
          :items="form.lists.listRelatorios"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
          sort-by="dataHoraAcao"
          :sort-desc="true"
        >
          <template v-slot:[`item.nome`]="{ item }">
            {{ item.nome }}
          </template>
          <template v-slot:[`item.tipoDisciplina`]="{ item }">
            {{ item.tipoDisciplina }}
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
          </template>
          <template v-slot:[`item.dataHoraAcao`]="{ item }">
            {{ $formatarDataHora(item.dataHoraAcao) }}
          </template>
          <template v-slot:[`item.acao`]="{ item }">
            {{ item.acao }}
          </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorios.length"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
    import pageLoadingMixin from "mixins/page-loading.mixin";
    import RelatorioDeLog from "services/relatorios-log/manter-disciplina-log.service";
    import ManterDisciplinaService from '~/services/manter-disciplina.service';
    export default {
        name: "RelatorioLogDisciplina",
        mixins: [pageLoadingMixin, RelatorioDeLog, ManterDisciplinaService],
    
        data: () => ({
        onReport: false,
        expanded: [],
        form: {
            filters: {
                disciplina: null,
                tipoDisciplina: null,
                situacao: null,
                dataInicio: null,
                dataFim: null,
            },
            lists: {
                listRelatorios: [],
                tiposDeDisciplina: [],
            },
            itemsPerPage: 10,
            geradorRelatorio: null,
            horaDaGeracao: null,
            totalDisciplina: 0,
        },
        headersAnalitico: [
            { text: "Nome da Disciplina", align: "center", value: "nome" },
            { text: "Tipo de Disciplina", align: "center", value: "tipoDisciplina" },
            { text: "Situação", align: "center", value: "ativo" },
            { text: "Data/Hora da ação", align: "center", value: "dataHoraAcao" },
            { text: "Ação", align: "center", value: "acao" },
        ],
        }),
        methods: {
        getFilteredHeader(headers) {
            return headers.filter(header => {
            if (header.onlyView) return !this.onReport;
            if (header.onlyReport) return this.onReport;
            return true;
            });
        },
        async buscarRelatorios() {
            const isValid = this.validarDatas();
            if (!isValid) return;
            if (!this.verificarFiltrosPreenchidos()) return;
    
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogDisciplina(this.$montarParamsFilters(preparedRequest));
            this.processarRespostaRelatorio(data);
            } finally {
            this.hidePageLoading();
            }
        },
        validarDatas() {
        const { dataInicio, dataFim } = this.form.filters;
        
        if (dataInicio && dataFim) {
          if (new Date(dataFim) < new Date(dataInicio)) {
            this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
            return false;
          }
          if (new Date(dataInicio) > new Date(dataFim)) {
            this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
            return false;
          }
        }
        return true;
      },
    
        verificarFiltrosPreenchidos() {
          const { disciplina, situacao, tipoDisciplina, dataInicio, dataFim } = this.form.filters;
          if (!disciplina && situacao == null && tipoDisciplina == null && !dataInicio && !dataFim) {
              this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
              return false;
          }
          
          return true;
        },
    
        async baixarCSVRelatorio() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogCSVDisciplina(this.$montarParamsFilters(preparedRequest));
            this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeLogDeDisciplinaCSV`);
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
    
        async baixarRelatorioPdf() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogPDFDisciplina(this.$montarParamsFilters(preparedRequest));
            const url = URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SIGFOCO.RelatórioDeLogDeDisciplina.pdf");
            document.body.appendChild(link);
            link.click();
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
        prepararRequisicao() {
            return {
            nome: this.form.filters.disciplina,
            tipo: this.form.filters.tipoDisciplina,
            dataInicio: this.form.filters.dataInicio,
            dataFim: this.form.filters.dataFim,
            ativo: this.form.filters.situacao,
            };
        },
    
        processarRespostaRelatorio(data) {
            this.form.geradorRelatorio = data.relatorio.geradorRelatorio;
            this.form.horaDaGeracao = data.relatorio.horaDaGeracao;
            this.form.length = data.relatorio?.totalDisciplina;
            this.form.lists.listRelatorios = data.relatorio?.logs;
        },

        resetForm() {
          this.form.filters.dataInicio = null;
          this.form.filters.dataFim = null;
    
          this.$nextTick(() => {
            this.$set(this.form.filters, 'dataInicio', null);
            this.$set(this.form.filters, 'dataFim', null);
          });
          this.form.filters.disciplina = null;
          this.form.filters.tipoDisciplina = null;
          this.form.filters.situacao = null;

          this.form.lists.listRelatorios = [];
        }
      },
      mounted() {
      this.$buscarTipoDeDisciplina().then(({ data }) => {
        this.form.lists.tiposDeDisciplina = data.lista;
      });
    }
    };
</script>
<style scoped>
.permissoes {
  padding: 1em !important;
  text-align: center;
  font-weight: 500;
}
.permissao {
  padding-right: 0.5em;
}
</style>